import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=edb200a6&scoped=true&"
import script from "./Textarea.vue?vue&type=script&lang=js&"
export * from "./Textarea.vue?vue&type=script&lang=js&"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=edb200a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb200a6",
  null
  
)

export default component.exports